export default __webpack_public_path__ + "static/media/benefit_11@2x.fe8e055d.png";